module.exports = __webpack_public_path__ + "linkedin.svg?16aa49c6c0a46d609183bd879abbef8b";